import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Logger } from '../../../../common/utils/logger';
import { BSCIndexedDB } from '../../../../services/indexed-db-service';
import { findStorageTarget, WebStorageType } from '../../../../services/web-storage-service';
import { setItemOverride } from '../set-item-override';
export var createWebStoragePassthrough = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(storageType) {
    var bscStorage, originalSetItem, overriddenStorageClass, caseSensitiveStorageType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          bscStorage = findStorageTarget(storageType);
          if (bscStorage.isAvailable) {
            _context.next = 4;
            break;
          }
          Logger.warn("No ".concat(storageType, " capabilities found"));
          return _context.abrupt("return");
        case 4:
          if (BSCIndexedDB.isAvailable) {
            _context.next = 7;
            break;
          }
          Logger.warn('IndexedDB is not available');
          return _context.abrupt("return");
        case 7:
          if (BSCIndexedDB.isBooted) {
            _context.next = 10;
            break;
          }
          _context.next = 10;
          return BSCIndexedDB.boot();
        case 10:
          originalSetItem = bscStorage.storage.setItem; // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
          // we have to override the entire utility with our own edition of the webStorage class
          overriddenStorageClass = {
            clear: bscStorage.clear.bind(bscStorage),
            key: bscStorage.key.bind(bscStorage),
            length: bscStorage.length.bind(bscStorage),
            removeItem: bscStorage.removeItem.bind(bscStorage),
            getItem: bscStorage.getItem.bind(bscStorage),
            setItem: setItemOverride(bscStorage, originalSetItem, storageType)
          };
          caseSensitiveStorageType = storageType === WebStorageType.LocalStorage ? 'localStorage' : 'sessionStorage';
          Object.defineProperty(window, caseSensitiveStorageType, {
            value: overriddenStorageClass,
            writable: true,
            configurable: true
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createWebStoragePassthrough(_x) {
    return _ref.apply(this, arguments);
  };
}();